module.exports = __webpack_public_path__ + "static/media/ct-scan (2).fda9039b.svg";